var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHapiId(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 8C2 5.79086 3.79086 4 6 4L18 4C20.2091 4 22 5.79086 22 8V14.7574C22 15.8182 21.5786 16.8356 20.8284 17.5858L19.5858 18.8284C18.8356 19.5786 17.8182 20 16.7574 20H6C3.79086 20 2 18.2091 2 16L2 8ZM6 6C4.89543 6 4 6.89543 4 8L4 16C4 17.1046 4.89543 18 6 18L16.7574 18C17.2878 18 17.7965 17.7893 18.1716 17.4142L19.4142 16.1716C19.7893 15.7965 20 15.2878 20 14.7574V8C20 6.89543 19.1046 6 18 6L6 6ZM7 16C6.44772 16 6 15.5523 6 15L6 9C6 8.44772 6.44772 8 7 8C7.55229 8 8 8.44772 8 9L8 15C8 15.5523 7.55228 16 7 16ZM10 15C10 15.2652 10.1054 15.5196 10.2929 15.7071C10.4804 15.8946 10.7348 16 11 16H16C16.2652 16 16.5196 15.8946 16.7071 15.7071L17.7071 14.7071C17.8946 14.5196 18 14.2652 18 14L18 10L18 9C18 8.44771 17.5523 8 17 8H11C10.4477 8 10 8.44772 10 9L10 15ZM15.5858 14H12V10L16 10L16 13.5858L15.5858 14Z",
    fill: "#0B0B17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHapiId);
export default __webpack_public_path__ + "static/media/hapi-id.4174df92f4da2b990151bee43507514b.svg";
export { ForwardRef as ReactComponent };